import env from '@/env';
import { readTheme, resolveTheme, themeStorageKey } from '@/utils/theme';

const CANVAS_COLOR = { light: '#ffffff', dark: '#111820' };

export function applyTheme(theme) {
  const canvas = CANVAS_COLOR[theme] ?? CANVAS_COLOR.light;
  document.body.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  document.documentElement.style.backgroundColor = canvas;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', canvas);
}

export function startTheme(store) {
  let storage;
  let media;
  try {
    storage = window.localStorage;
  } catch {
    /* storage is optional */
  }
  try {
    media = window.matchMedia('(prefers-color-scheme: dark)');
  } catch {
    /* resolve System to Light without media-query support */
  }
  store.commit('app/setThemePreference', readTheme(storage));
  const apply = () => {
    const resolved = resolveTheme(store.state.app.settingTheme, !!media?.matches);
    const theme = env.DARK_MODE_ENABLED ? resolved : 'light';
    applyTheme(theme);
    store.commit('app/setResolvedTheme', theme);
  };
  const onMedia = () => {
    if (store.state.app.settingTheme === 'system') apply();
  };
  const onStorage = (event) => {
    if (
      storage &&
      event.storageArea === storage &&
      (event.key === themeStorageKey || event.key === null)
    ) {
      store.commit('app/setThemePreference', readTheme(storage));
    }
  };
  const unwatch = store.watch((state) => state.app.settingTheme, apply, { flush: 'sync' });
  media?.addEventListener('change', onMedia);
  window.addEventListener('storage', onStorage);
  apply();
  return () => {
    unwatch();
    media?.removeEventListener('change', onMedia);
    window.removeEventListener('storage', onStorage);
  };
}
